"use strict";
var userAgent = require("../internals/environment-user-agent");
module.exports = /(?:ipad|iphone|ipod).*applewebkit/i.test(userAgent);
